import styles from './About.module.css';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SubPageTop from '../components/SubPageTop';
import Greeting from '../components/about/Greeting';
import History from '../components/about/History';
import Organization from '../components/about/Organization';

const TABS = [
    { label: "협회 소개", value: "greeting" },
    { label: "연혁", value: "history" },
    { label: "조직도", value: "organization" },
];

function About() {
    const [searchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    
    // URL 파라미터가 있고 유효한 탭이면 그것을 초기값으로, 없으면 첫 번째 탭
    const initialTab = TABS.find(t => t.value === tabParam)?.value || TABS[0].value;
    const [tab, setTab] = useState(initialTab);
    
    const tabListRef = useRef(null);
    const tabRefs = useRef([]);
    const [underlineStyle] = useState({});

    // URL 파라미터가 변경될 때 탭 상태 업데이트
    useEffect(() => {
        if (tabParam && TABS.find(t => t.value === tabParam)) {
            setTab(tabParam);
        }
    }, [tabParam]);
/*     useEffect(() => {
        const idx = TABS.findIndex((t) => t.value === tab);
        if (idx !== -1 && tabRefs.current[idx]) {
            const el = tabRefs.current[idx];
            setUnderlineStyle({
                width: el.offsetWidth + "px",
                left: el.offsetLeft + "px",
                bottom: "0px",
                transition: "all 0.32s cubic-bezier(.4,0,.2,1)",
            });
        }
    }, [tab]);
 */
    return (
        <div className={styles.subWrap}>
            <SubPageTop title="About" subTitle="협회소개" backgroundColor="#FE8B84" />
            <div className={styles.aboutTabs}>
                <ul className={styles.tabList} ref={tabListRef}>
                    {TABS.map((t, i) => (
                        <li
                            ref={(el) => (tabRefs.current[i] = el)}
                            key={t.value}
                            className={`${styles.tabItem} ${
                                tab === t.value ? styles.active : ""
                            }`}
                            onClick={() => setTab(t.value)}
                        >
                            {t.label}
                        </li>
                    ))}
                    <div
                        className={styles.tabUnderline}
                        style={underlineStyle}
                    ></div>
                </ul>
                <div className={styles.tabContent}>
                    {tab === "greeting" && <Greeting />}
                    {tab === "history" && <History />}
                    {tab === "organization" && <Organization />}
                </div>
            </div>
        </div>
    );
}

export default About;